import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectActiveServiceIndex,
  selectDisablePromotionSection,
  selectPublishTermsStatus,
  selectServiceIds,
} from '../../../../../../../selectors/publishTerms';
import { EPublishTermsStatus } from '../../../../../../../types/reducers/publishTerms';
import { selectIsBetPositionVisible } from '../../../../../../../selectors/betPosition';
import { selectIsMobileLayout } from '../../../../../../../selectors/layout';

import { ServicesSlider } from './components/ServicesSlider';
import { ServiceContainer } from './components/Services/ServiceContainer';

import { useServicesAnalyticsHandlers } from '../hooks';

import * as styles from './Services.container.css';
import { useVerticalServices } from './hooks';

export const ServicesContainer = () => {
  const serviceIds = useSelector(selectServiceIds);
  const status = useSelector(selectPublishTermsStatus);
  const activeServiceIndex = useSelector(selectActiveServiceIndex);
  const isBetPositionVisible = useSelector(selectIsBetPositionVisible);
  const allowDisablePromotionSection = useSelector(selectDisablePromotionSection);
  const isMobile = useSelector(selectIsMobileLayout);
  const { showVerticalServices } = useVerticalServices();

  const { onSliderScroll } = useServicesAnalyticsHandlers();

  const handleScrollSliderRight = React.useCallback(() => {
    onSliderScroll('right');
  }, [onSliderScroll]);

  const handleScrollSliderLeft = React.useCallback(() => {
    onSliderScroll('left');
  }, [onSliderScroll]);

  if (status !== EPublishTermsStatus.success) {
    return null;
  }

  const Services = serviceIds.map(serviceId => <ServiceContainer key={serviceId} serviceId={serviceId} />);

  if (showVerticalServices) {
    return <div className={styles.services}>{Services}</div>;
  }

  return (
    <ServicesSlider
      isMobile={isMobile}
      isBetPositionVisible={isBetPositionVisible}
      activeServiceIndex={activeServiceIndex}
      onScrollSliderRight={handleScrollSliderRight}
      onScrollSliderLeft={handleScrollSliderLeft}
      disabled={allowDisablePromotionSection}
    >
      {Services}
    </ServicesSlider>
  );
};
